const TokenKey = 'accessToken'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey);
  localStorage.removeItem("userData");
}

//控制登录后用户角色跳转页面
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return '/'
  return { name: 'auth-login' }
}

//获取用户信息
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

//是否登录
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(TokenKey)
}